<template>
  <div class="my-toast-box">
    <div class="my-toast-inner my-toast-error-inner" v-if="type=='error'">
      <div><img src="../../assets/img/toast/error.png" alt="">{{msg}}</div>
    </div>
    <div class="my-toast-inner my-toast-success-inner" v-if="type=='success'">
      <div><img src="../../assets/img/toast/icon_success.png" alt="">{{msg}}</div>
    </div>
  </div>
  <!-- success error -->
  <!-- E:\personCenter\pc_person_center\src\assets\icon_success.png -->
  <!-- let data = {
        msg: 'dsfdsfdsf',
        time: 300,
        type: 'success'
      }
      this.$_toast(data) -->
  <!-- error -->
  <!-- success -->
</template>
<script>

export default {
  name: 'toast',
  data () {
    return {
      type: 'success',
      msg: '',
      time: 3000
    }
  },
  mounted () {
    // setTimeout(() => {
    // 3s 后通过父级移除子元素的方式来移除该组件实例和 DOM 节点
    //   this.$destroy(true)
    //   this.$el.parentNode.removeChild(this.$el)

    // }, this.duration)
    let that = this
    setTimeout(() => {
      that.$destroy(true)
      that.$el.parentNode.removeChild(this.$el)
    }, that.time)
  }
}
</script>
<style lang="scss" scoped>
.my-toast-box {
  .my-toast-inner{
    width: 820px;
    height: 40px;
    line-height: 40px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: fixed;
    top: 10px;
    bottom: 0;
    left: 50%;
    right: 0;
    margin-left: -410px;

    font-size: 14px;
    z-index: 9999;

    border-radius: 4px;
    img{
      vertical-align: middle;
      margin-right: 9px;
    }
  }
  .my-toast-error-inner{
    // background:rgba(240,249,235,1);
    background:rgba(255,238,238,1);
     color: #FF6666;
  }
  .my-toast-success-inner{
    background:rgba(240,249,235,1);
    color: #78C06E;
    img{
      width: 18px;
      height: 18px;
    }
  }
}
</style>
